/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * リファレンスチャット種別
 */
export type ReferenceChatType = (typeof ReferenceChatType)[keyof typeof ReferenceChatType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReferenceChatType = {
  special_allocation_taxes: 'special_allocation_taxes',
  prefectural_special_allocation_taxes: 'prefectural_special_allocation_taxes',
  national_grants: 'national_grants',
  prefectural_grants: 'prefectural_grants',
  revenue_expenditure_account_items: 'revenue_expenditure_account_items',
} as const;
